export default {
  SET_OBECTS(state, data) {
    state.obects = data;
  },
  SET_WAREHOUSE(state, data) {
    state.warehouse = data;
  },

  SET_WAREHOUSE_SCROLL(state, data) {
    state.warehouse_scroll = {
      ...data,
      results: [...state.warehouse_scroll.results, ...data.results],
    };
  },
  SET_WAREHOUSE_TABLE(state, data) {
    state.warehouseTable = data;
  },
  SET_WAREHOUSE_ID(state, data) {
    state.warehouseId = data;
  },
  SET_MODALE_WAREHOUSE(state, data) {
    state.warehouseModale = data;
  },
  SET_WAREHOUSE_PINMODAL(state, data) {
    state.warehousePinModal = data;
  },
};
